import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Star, Send } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LaisserAvis = () => {
  const navigate = useNavigate();
  const [rating, setRating] = useState(5);
  const [hoverRating, setHoverRating] = useState(0);
  const [submitStatus, setSubmitStatus] = useState('');
  const [testimonialForm, setTestimonialForm] = useState({
    name: '',
    event_type: 'Mariage',
    comment: '',
    date: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      await axios.post(`${API}/testimonials`, {
        ...testimonialForm,
        rating: rating
      });
      
      setSubmitStatus('Merci pour votre avis! Il sera publié après validation.');
      setTestimonialForm({ name: '', event_type: 'Mariage', comment: '', date: '' });
      setRating(5);
      
      setTimeout(() => {
        navigate('/');
      }, 3000);
      
    } catch (error) {
      setSubmitStatus('Erreur lors de l\'envoi. Veuillez réessayer.');
    }
  };

  return (
    <div className="service-detail-page" data-testid="laisser-avis-page">
      {/* Background Video */}
      <div className="page-video-background">
        <iframe
          className="page-background-video"
          src="https://www.youtube.com/embed/AcQHHKsBFyE?autoplay=1&mute=1&loop=1&playlist=AcQHHKsBFyE&controls=0&showinfo=0&rel=0&modestbranding=1&playsinline=1&disablekb=1&iv_load_policy=3"
          title="CYGA EVENEMENT - Spectacle Pyrotechnique"
          frameBorder="0"
          allow="autoplay; encrypted-media"
        ></iframe>
      </div>

      {/* Hero Section */}
      <section className="testimonial-hero">
        <div className="testimonial-hero-overlay">
          <button onClick={() => navigate('/')} className="back-button" data-testid="back-button">
            <ArrowLeft /> Retour
          </button>
          
          <div className="testimonial-logo">
            <img 
              src="https://customer-assets.emergentagent.com/job_cyga-refresh/artifacts/iagmxpji_Cyga%20events%20Visuel%20Site-02.png" 
              alt="Cyga Events Logo" 
              className="logo-icon-img-large"
            />
            <img 
              src="https://customer-assets.emergentagent.com/job_cyga-refresh/artifacts/pw7229o4_Cyga%20events%20Visuel%20Site-04.png" 
              alt="Cyga Events" 
              className="logo-text-img-large"
            />
          </div>
          
          <h1 className="testimonial-hero-title" data-testid="page-title">
            LAISSEZ VOTRE<br/>
            <span className="highlight">AVIS</span>
          </h1>
          <p className="testimonial-hero-subtitle">
            Votre expérience compte pour nous
          </p>
        </div>
      </section>

      {/* Form Section */}
      <section className="testimonial-form-section">
        <div className="testimonial-form-container">
          <form onSubmit={handleSubmit} className="testimonial-form" data-testid="testimonial-form">
            
            <div className="form-group">
              <label>Votre Nom *</label>
              <input
                type="text"
                value={testimonialForm.name}
                onChange={(e) => setTestimonialForm({ ...testimonialForm, name: e.target.value })}
                placeholder="Ex: Sophie & Marc Dupont"
                required
                data-testid="testimonial-name-input"
              />
            </div>

            <div className="form-group">
              <label>Type d'Événement *</label>
              <select
                value={testimonialForm.event_type}
                onChange={(e) => setTestimonialForm({ ...testimonialForm, event_type: e.target.value })}
                required
                data-testid="testimonial-event-type-select"
              >
                <option value="Mariage">Mariage</option>
                <option value="Commune">Commune / Municipalité</option>
                <option value="Événementiel">Événement d'Entreprise</option>
                <option value="Autre">Autre</option>
              </select>
            </div>

            <div className="form-group">
              <label>Date de l'Événement *</label>
              <input
                type="text"
                value={testimonialForm.date}
                onChange={(e) => setTestimonialForm({ ...testimonialForm, date: e.target.value })}
                placeholder="Ex: Juillet 2024"
                required
                data-testid="testimonial-date-input"
              />
            </div>

            <div className="form-group">
              <label>Note *</label>
              <div className="rating-selector" data-testid="rating-selector">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    type="button"
                    className="star-button"
                    onClick={() => setRating(star)}
                    onMouseEnter={() => setHoverRating(star)}
                    onMouseLeave={() => setHoverRating(0)}
                    data-testid={`star-${star}`}
                  >
                    <Star
                      className={`rating-star ${
                        star <= (hoverRating || rating) ? 'filled' : ''
                      }`}
                      fill={star <= (hoverRating || rating) ? 'currentColor' : 'none'}
                    />
                  </button>
                ))}
                <span className="rating-text">{rating}/5</span>
              </div>
            </div>

            <div className="form-group">
              <label>Votre Avis *</label>
              <textarea
                value={testimonialForm.comment}
                onChange={(e) => setTestimonialForm({ ...testimonialForm, comment: e.target.value })}
                placeholder="Partagez votre expérience avec CYGA EVENEMENT..."
                rows="6"
                required
                data-testid="testimonial-comment-textarea"
              ></textarea>
            </div>

            <button type="submit" className="form-submit" data-testid="testimonial-submit-button">
              <Send className="submit-icon" />
              Envoyer mon Avis
            </button>

            {submitStatus && (
              <div className={`form-status ${submitStatus.includes('Erreur') ? 'error' : 'success'}`} data-testid="submit-status">
                {submitStatus}
              </div>
            )}
          </form>
        </div>
      </section>
    </div>
  );
};

export default LaisserAvis;
